import SocialsModalTableCheck from "../table-check"

export const SocialsAlertErrorPostDetails = ({ items, provider }) => {
    return <SocialsModalTableCheck rows={items} providers={provider} />
}
